import React from 'react';
import moment from 'moment';

const footerStyles = `
@keyframes footer-fade-in {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}
.app-footer {
  text-align: center;
  margin: 24px 0 32px;
  animation: footer-fade-in 0.5s ease both;
}
.app-footer-bar {
  height: 2px;
  background: linear-gradient(90deg, transparent, #1890ff55, transparent);
  margin: 0 auto 14px;
  width: 60%;
  max-width: 300px;
  border-radius: 2px;
}
.app-footer-name {
  font-size: 12px;
  font-weight: 600;
  color: #8c8c8c;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin: 0 0 3px;
}
.app-footer-copy {
  font-size: 11px;
  color: #bfbfbf;
  letter-spacing: 0.5px;
}
`;

function Footer() {
  return (
    <>
      <style>{footerStyles}</style>
      <div className="app-footer">
        <div className="app-footer-bar" />
        <p className="app-footer-name">
          {process.env.REACT_APP_PROJECT_NAME || 'No Env Project name'}{' '}
          <span style={{ color: '#1890ff', fontWeight: 700 }}>
            {process.env.REACT_APP_VERSION || '1.0.0'}
          </span>
        </p>
        <small className="app-footer-copy">
          &copy; {moment().format('YYYY')} · All rights reserved
        </small>
      </div>
    </>
  );
}

export default Footer;